import { Box, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const ItemWrapper = customStyled(Box)(({ theme: { colors, fontSizes, space } }) => ({
  fontSize: fontSizes[2],
  padding: `10px ${space[3]}px`,
  marginTop: space[3],
  textAlign: 'center',
}));

export const CheckBoxLabel1 = customStyled.label(() => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  columnGap: '13px',
}));

export const CheckBoxLabel = customStyled.label`
    cursor: pointer;
    display: flex;
    align-items: center;
    column-gap: 16px;
    label {
      margin-top: 16px;
    }
`;

export const Footer = customStyled(Box)(({ theme: { space, colors } }) => ({
  boxShadow: '0px -4px 30px 0px rgba(0, 0, 0, 0.15)',
  background: colors.white,
  bottom: 0,
  marginLeft: '-32px',
  padding: `${space[3]}px 0`,
  position: 'absolute',
  width: '100%',
  textAlign: 'center',
}));

export const ReplaceButton = customStyled(RoundCornerButton)(() => ({
  width: '90%',
}));
